import {debounce, has} from '@malt/common';

export function mixin(Hop) {
    Hop.debounce = debounce;

    /* eslint-disable indent */
    Hop.keys = Object.keys
        ? Object.keys
        : function (o) {
              const res = [];
              for (const k in o) {
                  if (has(o, k)) {
                      res.push(k);
                  }
              }
              return res;
          };
    /* eslint-enable indent */

    Hop.delegate = (el, event, selector, callback) => {
        function onEvent(e) {
            if (e.target && e.target.closest(selector)) {
                callback && typeof callback === 'function' && callback(e);
            }
        }

        el.addEventListener(event, onEvent);

        return function undelegate() {
            el.removeEventListener(event, onEvent);
        };
    };
}
